import sortBy from 'lodash-es/sortBy';
import React, { useCallback, useState } from 'react';
import { SidePanelParentPetDataFragment } from 'shared/types/graphql';
import styled from 'styled-components/macro';
import { PetSelectorListItem, SelectorDirection } from './PetSelectorListItem';

interface IPetSelectorList {
  allPets: SidePanelParentPetDataFragment[];
  selectedPet?: SidePanelParentPetDataFragment;
  selectPet?: (pet: SidePanelParentPetDataFragment) => void;
}
export const PetSelectorList = ({ allPets, selectedPet, selectPet }: IPetSelectorList): JSX.Element => {
  const [showAll, setShowAll] = useState(false);
  const remainingPets = sortBy(
    allPets.filter((allPet: SidePanelParentPetDataFragment) => allPet.id !== selectedPet?.id),
    (pet) => ((pet.organizationPet?.carePlanEnrollments?.length ?? 0) > 0 ? 0 : 1),
  );

  const selectorDirection = showAll ? SelectorDirection.Up : SelectorDirection.Down;
  const moreThanOnePet = allPets.length > 1;

  const handleSelectedPetClick = useCallback(() => {
    if (moreThanOnePet) {
      setShowAll((value) => !value);
    }
  }, [moreThanOnePet]);

  const handleNewPetSelected = useCallback(
    (pet: SidePanelParentPetDataFragment) => {
      if (selectPet) {
        selectPet(pet);
      }
      setShowAll(false);
    },
    [selectPet],
  );

  return (
    <Container moreThanOnePet={moreThanOnePet}>
      {selectedPet && (
        <PetSelectorListItem
          petName={selectedPet.name}
          organizationPet={selectedPet.organizationPet}
          species={selectedPet.species || ''}
          speciesType ={selectedPet.speciesType}
          isDeceased={!!selectedPet.computedIsDeceased}
          isActive={!!selectedPet.computedIsActive}
          photoUrl={selectedPet.photoUrl || ''}
          showSelector={moreThanOnePet}
          selectorDirection={selectorDirection}
          onClick={handleSelectedPetClick}
        />
      )}
      {showAll &&
        (remainingPets.length >= 1 ? (
          remainingPets.map((pet) => {
            return (
              <PetSelectorListItem
                key={pet.id}
                petName={pet.name}
                organizationPet={pet.organizationPet}
                species={pet.species || ''}
                speciesType = {pet.speciesType}
                isDeceased={!!pet?.computedIsDeceased}
                isActive={!!pet?.computedIsActive}
                photoUrl={pet.photoUrl || ''}
                onClick={(): void => handleNewPetSelected(pet)}
              />
            );
          })
        ) : (
          <NoPetsLabel>No other pets</NoPetsLabel>
        ))}
    </Container>
  );
};

const Container = styled.div<{ moreThanOnePet: boolean }>`
  border-radius: 7px;
  border: 1px solid #d2d2d2;
  cursor: ${({ moreThanOnePet }): string => {
    return moreThanOnePet ? 'pointer' : 'auto';
  }};
  margin: auto;
  &:hover {
    border-color: ${({ moreThanOnePet }): string => {
      return moreThanOnePet ? '  #7179a1' : '#d2d2d2';
    }};
  }
`;

const NoPetsLabel = styled.div`
  text-align: center;
  font-size: 14px;
  color: #6f7591;
  padding: 8px;
`;
